import { useState } from "react";

export function useFormState(initialState) {
  const [state, setState] = useState(initialState);

  const setFormState = (key, value) => {
    setState({ ...state, [key]: value });
  };

  const handleChange = (e) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  const resetFormState = () => {
    setState(initialState);
  };

  const get = (fallback = "") => {
    return (key) => state[key] || fallback;
  };

  return [state, handleChange, setFormState, resetFormState];
}

export function useError() {
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState("");

  const set = ({ message, autoDismiss = true }) => {
    setMessage(message);
    setShow(true);

    if (!autoDismiss) {
      return;
    }

    setTimeout(() => {
      setShow(false);
    }, 10000);
  };

  const clear = () => {
    setShow(false);
    setMessage("");
  };

  return {
    show,
    clear,
    message,
    set,
  };
}
